<div   class="popup-header"> 	{{data.formData.title}}</div>

<div mat-dialog-content>
  <p style="font-size: 12pt;">{{data.formData.message}}</p>
</div>
<div mat-dialog-actions   align="end">
  <button [ngClass]="data.formData.class ? data.formData.class[0] : 'theme-button'" style="margin:5px"  (click)="onNoClick()" cdkFocusInitial>{{data.formData.buttons? data.formData.buttons[0] : 'No' }}</button>
  <button [ngClass]="data.formData.class ? data.formData.class[1] : 'warn-button'" style="margin:5px"  mat-dialog-close="true" >{{data.formData.buttons? data.formData.buttons[1] : 'Sure' }}</button>
</div>



